import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';

const METODOS = [
  { id: 'pix', label: 'PIX' },
  { id: 'cartao', label: 'Cartão de Crédito' },
  { id: 'paypal', label: 'PayPal' },
];

export default function Checkout() {
  const [carrinho, setCarrinho] = useState([]);
  const [email, setEmail] = useState('');
  const [metodo, setMetodo] = useState('pix');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/cart').then(r => setCarrinho(r.data.carrinho || []));
    if (user?.email) setEmail(user.email);
  }, [user]);

  const total = carrinho.reduce(
    (sum, item) => sum + parseFloat(item.preco || 0) * (item.quantidade || 1),
    0
  );

  async function handlePagar(e) {
    e.preventDefault();
    if (!carrinho.length) return;
    setError('');
    setLoading(true);

    const payload = {
      cart: carrinho,
      total: total.toFixed(2),
      email,
      product_id: carrinho[0]?.id,
    };

    try {
      if (metodo === 'pix') {
        const { data } = await api.post('/checkout/pix', payload);
        navigate('/checkout/pix', { state: data });

      } else if (metodo === 'cartao') {
        const { data } = await api.post('/checkout/cartao', payload);
        window.location.href = data.init_point;

      } else if (metodo === 'paypal') {
        const { data } = await api.post('/checkout/paypal', payload);
        window.location.href = data.approvalUrl;
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Erro ao processar pagamento.');
    } finally {
      setLoading(false);
    }
  }

  if (!carrinho.length) {
    return (
      <main className="page-container">
        <h2>Checkout</h2>
        <p>Seu carrinho está vazio.</p>
      </main>
    );
  }

  return (
    <main className="page-container">
      <h2>Checkout</h2>
      <div style={{ display: 'grid', gap: '24px', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))' }}>

        {/* Resumo do carrinho */}
        <div className="card">
          <h3 style={{ marginTop: 0 }}>Resumo do pedido</h3>
          {carrinho.map(item => (
            <div key={item.id} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #e2e8f0' }}>
              <span>{item.nome}</span>
              <span>x{item.quantidade || 1} — R$ {(parseFloat(item.preco) * (item.quantidade || 1)).toFixed(2)}</span>
            </div>
          ))}
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '16px', fontWeight: 700, fontSize: '1.1rem' }}>
            <span>Total</span>
            <span>R$ {total.toFixed(2)}</span>
          </div>
        </div>

        {/* Formulário de pagamento */}
        <form onSubmit={handlePagar} className="card" style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <h3 style={{ marginTop: 0 }}>Pagamento</h3>

          {error && <div className="alert-error">{error}</div>}

          <label style={{ display: 'flex', flexDirection: 'column', gap: '6px', fontWeight: 500 }}>
            Email para receber confirmação
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              autoComplete="email"
              style={{ border: '1px solid #cbd5e1', borderRadius: '8px', padding: '10px 12px' }}
            />
          </label>

          <div style={{ display: 'flex', gap: '8px' }}>
            {METODOS.map(m => (
              <button
                key={m.id}
                type="button"
                onClick={() => setMetodo(m.id)}
                style={{
                  flex: 1,
                  padding: '10px',
                  border: `2px solid ${metodo === m.id ? '#0f172a' : '#e2e8f0'}`,
                  borderRadius: '8px',
                  background: metodo === m.id ? '#0f172a' : '#fff',
                  color: metodo === m.id ? '#fff' : '#0f172a',
                  fontWeight: 600,
                  cursor: 'pointer',
                }}
              >
                {m.label}
              </button>
            ))}
          </div>

          {metodo === 'pix' && (
            <div className="alert-info" style={{ fontSize: '0.9rem' }}>
              Após confirmar, você receberá o QR Code para pagar via PIX. O acesso é liberado assim que o pagamento for confirmado.
            </div>
          )}
          {metodo === 'cartao' && (
            <div className="alert-info" style={{ fontSize: '0.9rem' }}>
              Você será redirecionado para o ambiente seguro do Mercado Pago para digitar os dados do cartão.
            </div>
          )}
          {metodo === 'paypal' && (
            <div className="alert-info" style={{ fontSize: '0.9rem' }}>
              Você será redirecionado para o PayPal para aprovar o pagamento.
            </div>
          )}

          <button type="submit" className="btn-primary" disabled={loading} style={{ padding: '14px' }}>
            {loading ? 'Processando...' : `Pagar R$ ${total.toFixed(2)} via ${METODOS.find(m => m.id === metodo)?.label}`}
          </button>
        </form>

      </div>
    </main>
  );
}
